import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: '[versatileListItem]'
})
export class VersatileListItemDirective {
    constructor(public template: TemplateRef<any>) {
    }
}
